import { Link } from "@chakra-ui/react";
import { RiChat1Line } from "@remixicon/react";

import EmptyState, { EmptyStateProps } from "@/common/components/EmptyState";

type Props = EmptyStateProps & {
  isFiltered?: boolean;
};

export const FeedbackEmptyState = ({
  isLoading,
  isFiltered,
  isError,
  onRetry,
  ...rest
}: Props) => {
  return (
    <EmptyState
      description={
        isFiltered ? (
          "Try adjusting the filters"
        ) : (
          <>
            You can start collecting feedback automatically with{" "}
            <Link href="https://docs.reflag.com/product-handbook/automated-feedback-surveys">
              automated feedback surveys
            </Link>{" "}
            through our{" "}
            <Link
              href="https://docs.reflag.com/quickstart/supported-languages-frameworks"
              target="_blank"
            >
              SDKs
            </Link>{" "}
            or{" "}
            <Link href="https://docs.reflag.com/api/http-api" target="_blank">
              HTTP API
            </Link>
          </>
        )
      }
      error="Failed to load feedback"
      flexGrow={1}
      icon={<RiChat1Line size="48px" />}
      isError={isError}
      isLoading={isLoading}
      title={isFiltered ? "No feedback found" : "No feedback yet"}
      onRetry={onRetry}
      {...rest}
    />
  );
};
